import { z } from 'zod';

export const ColumnFilterDisallowedReason = z.enum([
  'unique-values-required',
  'not-number',
  'not-date',
  // TODO: Right now, we only provide the scalar input when there are no blanks
  'has-blanks',
]);

export type ColumnFilterDisallowedReason = z.infer<
  typeof ColumnFilterDisallowedReason
>;
